var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#57606A;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;} .st1{fill:none;stroke:#57606A;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st2{fill:none;stroke:#57606A;stroke-width:2;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12,25 4,25 4,7 28,7 28,13 "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "8,11 16,18 24,11 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.7,
    y1: 16,
    x2: 8,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.8,22c-0.8,0.2-1.6,0-1.9-0.6c-0.3-0.6-0.1-1.4,0.5-2c-0.7-0.7-1.5-1.2-2.5-1.5c-0.2,0.8-0.8,1.4-1.4,1.4 s-1.2-0.6-1.4-1.4c-0.9,0.3-1.8,0.8-2.5,1.5c0.6,0.6,0.8,1.4,0.5,2C19.8,22,19,22.2,18.2,22c-0.1,0.5-0.2,1-0.2,1.5s0.1,1,0.2,1.5 c0.8-0.2,1.6,0,1.9,0.6c0.3,0.6,0.1,1.4-0.5,2c0.7,0.7,1.5,1.2,2.5,1.5c0.2-0.8,0.8-1.4,1.4-1.4s1.2,0.6,1.4,1.4 c0.9-0.3,1.8-0.8,2.5-1.5c-0.6-0.6-0.8-1.4-0.5-2c0.3-0.6,1.1-0.8,1.9-0.6c0.1-0.5,0.2-1,0.2-1.5S28.9,22.5,28.8,22z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.5,
    cy: 23.5,
    r: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSetting);
export default __webpack_public_path__ + "static/media/email-setting.7a9ee6d4ede759071822407d38c5beac.svg";
export { ForwardRef as ReactComponent };